import { CustomerPersonTypes } from './Customers.enums';

export const customerPersonTypesLabel = {
  [CustomerPersonTypes.Natural]: 'Pessoa Física',
  [CustomerPersonTypes.Legal]: 'Pessoa Jurídica',
};
